/* eslint-disable */
import React from "react";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// @material-ui/core
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Accessibility from "@material-ui/icons/Accessibility";
import useMediaQuery from "@material-ui/core/useMediaQuery";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";

import CardFooter from "components/Card/CardFooter.js";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import { db } from "../Firebase/firebase.js";
import ls from "local-storage";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(styles);

export default function Dashboard() {
  var delays = 80,
    durations = 500;
  const Userschart = {
    data: {
      labels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      series: [
        [
          ls.get("jan"),
          ls.get("feb"),
          ls.get("mar"),
          ls.get("apr"),
          ls.get("may"),
          ls.get("jun"),
          ls.get("jul"),
          ls.get("aug"),
          ls.get("sep"),
          ls.get("oct"),
          ls.get("nov"),
          ls.get("dec"),
        ],
      ],
    },
    options: {
      axisX: {
        showGrid: false,
      },
      low: 0,
      high: 200,
      chartPadding: {
        top: 0,
        right: 5,
        bottom: 0,
        left: 0,
      },
    },
    responsiveOptions: [
      [
        "screen and (max-width: 640px)",
        {
          seriesBarDistance: 5,
          axisX: {
            labelInterpolationFnc: function (value) {
              return value[0];
            },
          },
        },
      ],
    ],
    animation: {
      draw: function (data) {
        if (data.type === "bar") {
          data.element.animate({
            opacity: {
              begin: (data.index + 1) * delays,
              dur: durations,
              from: 0,
              to: 1,
              easing: "ease",
            },
          });
        }
      },
    },
  };

  let history = useHistory();
  const theme = useTheme();
  var desktop = useMediaQuery(theme.breakpoints.between("2490", "4000"));
  const classes = useStyles();
  const [users, setusers] = React.useState(0);
  const [events, setevents] = React.useState(0);
  const [brookfish, setbrookfish] = React.useState(0);
  const [salmonfish, setsalmonfish] = React.useState(0);
  const [cuskfish, setcuskfish] = React.useState(0);
  const [toguefish, settoguefish] = React.useState(0);

  React.useEffect(() => {
    if (ls.get("currentuser") === "") {
      history.push("/login");
    } else {
      getusers();
      getEvents();
      getfish();
      getchartdata();
    }
  }, []);

  const getchartdata = () => {
    let newArray = [];
    db.collection("users")
      .where("type", "==", "customer")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          newArray.push(doc.data().date);
        });
        getUserCount(newArray);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  };

  const getUserCount = (array) => {
    let jan = 0;
    let feb = 0;
    let mar = 0;
    let apr = 0;
    let may = 0;
    let jun = 0;
    let jul = 0;
    let aug = 0;
    let sep = 0;
    let oct = 0;
    let nov = 0;
    let dec = 0;
    for (let i = 0; i < array.length; i++) {
      let date = new Date(array[i]);
      if (date.getMonth() === 0) {
        jan++;
      } else if (date.getMonth() === 1) {
        feb++;
      } else if (date.getMonth() === 2) {
        mar++;
      } else if (date.getMonth() === 3) {
        apr++;
      } else if (date.getMonth() === 4) {
        may++;
      } else if (date.getMonth() === 5) {
        jun++;
      } else if (date.getMonth() === 6) {
        jul++;
      } else if (date.getMonth() === 7) {
        aug++;
      } else if (date.getMonth() === 8) {
        sep++;
      } else if (date.getMonth() === 9) {
        oct++;
      } else if (date.getMonth() === 10) {
        nov++;
      }else if (date.getMonth() === 11) {
        dec++;
      }
       else {
       
      }
    }
    ls.set("jan", jan);
    ls.set("feb", feb);
    ls.set("mar", mar);
    ls.set("apr", apr);
    ls.set("may", may);
    ls.set("jun", jun);
    ls.set("jul", jul);
    ls.set("aug", aug);
    ls.set("sep", sep);
    ls.set("oct", oct);
    ls.set("nov", nov);
    ls.set("dec", dec);
  };
  const getusers = () => {
    db.collection("users")
      .where("type", "==", "customer")
      .get()
      .then((querySnapshot) => {
        setusers(querySnapshot.size);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  };
  const getfish = () => {
    db.collection("fishRegistration")
      .doc("Brook Trout")
      .collection("Brook Trout")
      .get()
      .then((querySnapshot) => {
        setbrookfish(querySnapshot.size);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
    db.collection("fishRegistration")
      .doc("Cusk")
      .collection("Cusk")
      .get()
      .then((querySnapshot) => {
        setcuskfish(querySnapshot.size);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
    db.collection("fishRegistration")
      .doc("Salmon")
      .collection("Salmon")
      .get()
      .then((querySnapshot) => {
        setsalmonfish(querySnapshot.size);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
    db.collection("fishRegistration")
      .doc("Togue")
      .collection("Togue")
      .get()
      .then((querySnapshot) => {
        settoguefish(querySnapshot.size);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  };
  const getEvents = () => {
    db.collection("events")
      .get()
      .then((querySnapshot) => {
        setevents(querySnapshot.size);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  };
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={6} md={4}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Accessibility />
              </CardIcon>
              <p className={classes.cardCategory}>Users</p>
              <h3 className={classes.cardTitle}>{users}</h3>
            </CardHeader>
            <CardFooter stats></CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={4}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <Icon>emoji_events</Icon>
              </CardIcon>
              <p className={classes.cardCategory}>Events</p>
              <h3 className={classes.cardTitle}>{events}</h3>
            </CardHeader>
            <CardFooter stats></CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={4}>
          <Card>
            <CardHeader color="primary" stats icon>
              <CardIcon color="primary">
                <Icon>set_meal</Icon>
              </CardIcon>
              <p className={classes.cardCategory}>Fish</p>
              <h3 className={classes.cardTitle}>
                {brookfish + toguefish + salmonfish + cuskfish}
              </h3>
            </CardHeader>
            <CardFooter stats></CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <h3 style={{ color: "black" }}>Statistics</h3>
          <Card chart style={{ border: 0 }}>
            <CardHeader style={{ backgroundColor: "#171942" }}>
              <ChartistGraph
                className="ct-chart"
                data={Userschart.data}
                type="Bar"
                options={Userschart.options}
                responsiveOptions={Userschart.responsiveOptions}
                listener={Userschart.animation}
                style={{ height: desktop ? 500 : 300 }}
              />
            </CardHeader>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
